// removed by extract-text-webpack-plugin
module.exports = {"inputAndButtonHeight":"3rem","Blackberry":"#333D47","Bluecheese":"#615CFF","Radish":"#C20026","inputWithButtonWrapper":"Gb80e25","eventStatus":"G0a6e00 G3c3c24"};